<kilowant-header [isBuyer]="true" 
                 [title]="(existingContractId>0)?'Update Price Plan':'Add Price Plan'" 
                 [myKilowant]="(user.isAdvisor)?true:false" 
                 [showTtitleAsSecond]="(user.isAdvisor)?true:false"
                 [showAccountList]="false"
                 class="addContractHeader"></kilowant-header>
<div class="overWrapper">
  <ol class="wrapperMain kilowant-list">
    <li class="home-step" [class]="(step==1)?'':('inactive'+((step>1)?' with-link':''))" #step1>
      <h3 class="title" #body>Selected Utility Account(s)</h3>
      @if (step>1) {
        <div class="inactive-step" (click)="gotoStep(1)"></div>
      }
      @if (step==1 && existingContract!=null) {
        <div class="home-block body mb-10">
          @for (aData of accountsSelector; track aData; let p = $index) {
            @if (aData.group!='') {
              <div [class]="(p>0)?'mt-20':''" class="group">{{aData.group}}</div>
            }
            <div class="checkbox-list"><label><input type="checkbox" [checked]="ifItemSelected(aData.id)" [disabled]="(step>1)||!ifItemSelectable(aData.id)" (change)="selectItem(aData.id)"> {{aData.text}}</label></div>
          }
        </div>
        @if (this.errorY().showError()) {
          <div class="error-block">{{errorY().error}}</div>
        }
        @if (step==1) {
          <div class="block-buttons full-width under-card">
            @if (step==1) {
              <button type="button" (click)="cancel()">Cancel</button>
            }
            <button type="button" class="highlighted-button" (click)="finishStep1()">Next</button>
          </div>
        }
        <div>&nbsp;</div>
      }
    </li>

    <li class="home-step" [class]="(step==2)?'':('inactive'+((step>2)?' with-link':''))" #step2>
      <h3>Complete the Price Plan Terms</h3>
    @if (step>2) {
      <div class="inactive-step" (click)="gotoStep(2)"></div>
    }
    @if (step==2) {
      <div class="form">
        @if (existingContract!=null) {
          <div class="body">
            <input type="text" [class]="getClassesForInput('currentSupplierName', true, existingContract.supplierName)" name="currentSupplierName" [(ngModel)]="existingContract.supplierName" (input)="resetError('currentSupplierName')" placeholder="Supplier Name" maxlength="50" />
            @if (getVisibilityForLabel(existingContract.supplierName)) {
              <div class="placeholder">Supplier Name</div>
            }
            <input type="text" [class]="getClassesForInput('currentSupplierPrice', true, (existingContract.price==null)?null:''+existingContract.price)" name="currentSupplierPrice" [(ngModel)]="existingContract.price" (input)="resetError('currentSupplierPrice')"
              (focus)="focusField('currentSupplierPrice')" (focusout)="focusOutField('currentSupplierPrice')" [placeholder]="(focusedField()=='currentSupplierPrice')?'0.00000':'Price $/kWh'" [allowNegativeNumbers]="false" mask="separator.5" thousandSeparator="" />
            @if (getVisibilityForLabel((existingContract.price==null)?null:''+existingContract.price)) {
              <div class="placeholder">Price $/kWh</div>
            }
            <input matInput [matDatepicker]="picker1" [formControl]="termFrom" (click)="picker1.open(); resetError('termFrom');" [class]="getClassesForInput('termFrom', true, (termFrom.value==null)?null:termFrom.value.toString())" [matDatepickerFilter]="boundInactiveDatesFilter" placeholder="Service Start, 1st meter read on or after">
            <mat-datepicker #picker1 startView="multi-year" (yearSelected)="chosenYearHandler($event, termFrom)" (monthSelected)="chosenMonthHandler($event, termFrom, 'termFrom', picker1)"></mat-datepicker>
            @if (getVisibilityForLabel((termFrom.value==null)?null:termFrom.value.toString())) {
              <div class="placeholder">Service Start, 1st meter read on or after</div>
            }
            <input matInput [matDatepicker]="picker2" [formControl]="termTo" (click)="picker2.open(); resetError('termTo');" [class]="getClassesForInput('termTo', true, (termTo.value==null)?null:termTo.value.toString())" [matDatepickerFilter]="boundInactiveDatesFilterTermTo" placeholder="Service End, 1st meter read on or after">
            <mat-datepicker #picker2 startView="multi-year" (yearSelected)="chosenYearHandler($event, termTo)" (monthSelected)="chosenMonthHandler($event, termTo, 'termTo', picker2)">
            </mat-datepicker>
            @if (getVisibilityForLabel((termTo.value==null)?null:termTo.value.toString())) {
              <div class="placeholder">Service End, 1st meter read on or after</div>
            }
            @if (this.errorY().showError()) {
              <div class="error-block">{{errorY().error}}</div>
            }
          </div>
        }
        @if (step==2) {
          <div class="block-buttons full-width under-card">
            <button type="button" (click)="gotoStep(1)">Back</button>
            <button type="button" class="highlighted-button" (click)="finishStep2()">Next</button>
          </div>
        }
        <div>&nbsp;</div>
      </div>
    }
  </li>
  <li class="home-step" [class]="(step==3)?'':('inactive'+((step>3)?' with-link':''))" #step3>
    <h3>Upload Photo or Copy of Price Plan</h3>
  @if (step==3) {
    <div class="form">
      <div class="body">
        @if ((fileToUpload==null && existingContract.contractDocument==null)) {
          <label class="formLabel" [class]="(errorY().isWrong('fileToUpload'))?'error':''">
            CHOOSE FILES
            <span>no file selected</span>
            <input type="file" name="fileToUpload" class="required" value="" placeholder="Bill Image" (change)="handleFileInput($event)" />
          </label>
        }
        @if ((fileToUpload!=null || existingContract.contractDocument!=null)) {
          <div class="files-list">
            @if (fileToUpload!=null) {
              <span>1 file selected</span>
            }
            <ul>
              @if (fileToUpload!=null) {
                <li><a (click)="deleteFile(false)"></a><div class="link" (click)="downloadFile(false)">{{fileToUpload.name}}</div></li>
              }
              @if (existingContract.contractDocument!=null) {
                <li><a (click)="deleteFile(true)"></a><div class="link" (click)="downloadFile(true)">{{existingContract.contractDocument.value}}</div></li>
              }
            </ul>
          </div>
        }
        @if (this.errorY().showError()) {
          <div class="error-block">{{errorY().error}}</div>
        }
      </div>
      @if (step==3) {
        <div class="block-buttons full-width under-card mb-20">
          <button type="button" (click)="gotoStep(2)">Back</button>
          @if (existingContractId > 0) {
            <button type="button" class="highlighted-button" (click)="sendForm()">Update</button>
          }
          @if (existingContractId == 0) {
            <button type="button" class="highlighted-button" (click)="sendForm()">Add</button>
          }
        </div>
      }
    </div>
  }
</li>
</ol>
</div>
